import { render, staticRenderFns } from "./SmsMessage.vue?vue&type=template&id=51878f34"
import script from "./SmsMessage.vue?vue&type=script&lang=js"
export * from "./SmsMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51878f34')) {
      api.createRecord('51878f34', component.options)
    } else {
      api.reload('51878f34', component.options)
    }
    module.hot.accept("./SmsMessage.vue?vue&type=template&id=51878f34", function () {
      api.rerender('51878f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sms/SmsMessage.vue"
export default component.exports